import { BlockTree } from './blocked.tree';


// MenuBlockElement
export class BlockElement {
  public TagName: string ;
  public id: string ;
  public text: string ;
  public pageUrl: string;
  public profilImageUrl: string;
  public order: number;
  // list of items (with children) constituting the block's treeview
  public InnerElementsList: Array<BlockTree>;
}
